// FILE: src/hooks/useAddressSuggestions.js
// The Google places library for an address form, or null while loading,
// when no key is configured, or when Google can't be used. Only the address
// forms call this, so the Maps script is loaded only on those pages (once).
import { useEffect, useState } from "react";
import {
  getAddressAutocompleteConfig,
  loadPlacesLibrary,
  loadedPlacesLibrary,
  onSuggestionsUnavailable,
  suggestionsUnavailable
} from "../services/addressSuggestions";

export default function useAddressSuggestions() {
  const [places, setPlaces] = useState(() => loadedPlacesLibrary());

  useEffect(() => {
    let cancelled = false;
    const off = onSuggestionsUnavailable(() => !cancelled && setPlaces(null));
    if (!places && !suggestionsUnavailable()) {
      getAddressAutocompleteConfig()
        .then((cfg) => (cfg ? loadPlacesLibrary(cfg.apiKey) : null))
        .then((lib) => {
          if (!cancelled && lib && !suggestionsUnavailable()) setPlaces(lib);
        })
        .catch((err) => {
          // Plain fields keep working; say why once for whoever is debugging.
          if (process.env.NODE_ENV !== "test") console.warn("Address suggestions are off:", err?.message || err);
        });
    }
    return () => {
      cancelled = true;
      off();
    };
    // Run once per form: the library is cached for the whole visit.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return places;
}
